import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from './authService';

export const vendorTaxProfileApi = {
  get: async () => {
    const response = await api.get('/vendor/tax-profile');
    return response.data;
  },
  update: async (data) => {
    const response = await api.put('/vendor/tax-profile', data);
    return response.data;
  },
};

export const vendorStripeConnectApi = {
  status: async () => {
    const response = await api.get('/vendor/stripe-connect/status');
    return response.data;
  },
  onboard: async (payload = {}) => {
    const response = await api.post('/vendor/stripe-connect/onboard', payload);
    return response.data;
  },
  dashboardLink: async () => {
    const response = await api.post('/vendor/stripe-connect/dashboard-link');
    return response.data;
  },
  disconnect: async (payload = { delete_remote: true }) => {
    const response = await api.post('/vendor/stripe-connect/disconnect', payload);
    return response.data;
  },
};

export const useVendorTaxProfile = (options = {}) =>
  useQuery({
    queryKey: ['vendor-tax-profile'],
    queryFn: () => vendorTaxProfileApi.get(),
    staleTime: 60 * 1000,
    ...options,
  });

export const useUpdateVendorTaxProfile = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: vendorTaxProfileApi.update,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['vendor-tax-profile'] });
      queryClient.invalidateQueries({ queryKey: ['vendor-stripe-connect'] });
      options.onSuccess?.(data);
    },
    onError: options.onError,
  });
};

export const useVendorStripeConnect = (options = {}) =>
  useQuery({
    queryKey: ['vendor-stripe-connect'],
    queryFn: () => vendorStripeConnectApi.status(),
    staleTime: 30 * 1000,
    ...options,
  });
